import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem, space } from '@gbi/ui';
import tokens from '../../assets/styles/tokens';

// Label/value row for TargetPriceOrderReview (subtotal, savings, total at
// execution). GTT-owned so its styling can diverge from the shared
// InformationList/InformationListItem components used elsewhere in the app.
// The label is title/300 on every row; the value's style differs per row, so
// the caller passes it as a ready text style (`valueCss`).
const ReviewInfoRowContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${rem(space[16])};
`;

const ReviewInfoLabel = styled.p`
  margin: 0;
  min-width: 0;
  ${tokens.type.title[300]}
  color: ${tokens.color.text.primary};
`;

// The value keeps to one line and the label takes the rest, so a long label
// ("Estd. Total at Execution") never wraps beside a short amount.
const ReviewInfoValue = styled.p`
  margin: 0;
  flex-shrink: 0;
  white-space: nowrap;
  text-align: right;
  ${({ valueCss }) => valueCss}
`;

const defaultValueCss = `
  ${tokens.type.body[300]}
  color: ${tokens.color.text.primary};
`;

const ReviewInfoRow = ({ label, value, valueCss }) => (
  <ReviewInfoRowContainer>
    <ReviewInfoLabel>{label}</ReviewInfoLabel>
    <ReviewInfoValue valueCss={valueCss}>{value}</ReviewInfoValue>
  </ReviewInfoRowContainer>
);

ReviewInfoRow.propTypes = {
  label: PropTypes.node,
  value: PropTypes.node,
  // CSS for the value: a library text style and a colour.
  valueCss: PropTypes.string,
};

ReviewInfoRow.defaultProps = {
  valueCss: defaultValueCss,
};

export default ReviewInfoRow;
